import {
  Box,
  Button,
  Modal,
  TextareaAutosize,
  TextField,
} from "@material-ui/core";
import React from "react";
import { updateGeneralUseQuery } from "../../../Apis/GeneralUseQueryApi";

const EditGeneralQueryModal = ({ fetchData, open, setOpen, data }) => {
  const [loading, setLoading] = React.useState(false);
  const [query, setQuery] = React.useState(data.content);
  const [description, setDescription] = React.useState(data.description);
  const [order, setOrder] = React.useState(data.order);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    if (query) {
      const formData = {
        query: query,
        description: description,
        sport_type: data.sport_type,
        order: order,
      };
      try {
        const res = await updateGeneralUseQuery(formData, data.id);
        if (res && res?.status === 201) {
          setOpen(false);
          fetchData();
          event.target.query.value = "";
        }
      } catch (error) {
        console.error(error.response);
      }
    }
    setLoading(false);
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxWidth: "800px",
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <h3 className="fs-3">Edit General SDQL Form</h3>
        <form onSubmit={(e) => handleSubmit(e)}>
          <TextField
            style={{ width: "100%", marginBottom: "20px" }}
            type="text"
            name="query"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            label="SDQL"
            variant="standard"
            required
          />

          <TextareaAutosize
            aria-label="Description"
            minRows={3}
            placeholder="Description"
            name="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{
              width: "100%",
              marginBottom: "20px",
              borderRadius: "10px",
              borderColor: "rgba(0, 0, 0, 0.42)",
              padding: "10px",
            }}
          />

          <TextField
            style={{ width: "100%", marginBottom: "20px" }}
            type="number"
            name="order"
            value={order}
            onChange={(e) => setOrder(e.target.value)}
            label="Order"
            variant="standard"
            required
          />

          <Button
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
          >
            save
          </Button>
        </form>
      </Box>
    </Modal>
  );
};

export default EditGeneralQueryModal;
